module.exports = __webpack_public_path__ + "img/og-image_handbook_cn.42b11c4.jpg";